import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, ToolbarComponent } from '../../../../../components'
import { routeHeadCells } from '../../../../../shared/data/headCells'
import { RouteForm } from './components/RouteForm'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import RouteDetail, { StopDetail } from './components/RouteDetail'
import AddStop, { AddNewStop, ManualStop, SearchStop } from './components/AddStop'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { useSelector } from 'react-redux'
import { ImportIcon } from '../../../../../assets/icons'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'
import { toast } from 'react-toastify'

export const Route = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  const [form, setForm] = useState(false)
  const [detail, setDetail] = useState(false)
  const [stopOpen, setStopOpen] = useState(false)
  const [update, setUpdate] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const [search, setSearch] = useState('')
  const [schoolName, setSchoolName] = React.useState('')
  const [addnew, setAddnew] = useState(false)
  const [searchStop, setSearchstop] = useState(false)
  const [addManualStop, setaddManualstop] = useState(false)
  const [stopDetails, setStopDetails] = useState(false)
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const { data: routeData, count,refetch } = useGlobal({
    userUrl: `${urls.ROUTE_GET}${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&keyword=${search}`,
  })
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  // const { data: searchRoute } = useGlobal({
  //   userUrl: `${urls.ROUTE_SEARCH}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}&keyword=${search}`,
  // })
  const [step, setStep] = useState(1)

  const no_data_msg =
    customRole == 'Admin'
      ? 'Add route to start over'
      : schoolName
        ? 'Add route to start over'
        : 'Select school to see routes'

  const rowData = routeData || []
  const handleClose = () => {
    if (update) {
      setUpdate(false)
      setStep(1)
    } else {
      setForm(false)
      setStep(1)
    }
  }
  const setHandleClose = () => {
    setAddnew(false)
  }
  const setHandleOpen = () => {
    setAddnew(true)
    setStopOpen(false)
    setDetail(false)
  }
  const setSearchOpen = () => {
    setSearchstop(true)
    setAddnew(false)
  }
  const setsetaddManualstopOpen = () => {
    setaddManualstop(true)
    setStopOpen(false)
    setSearchstop(false)
    setStopDetails(false)
    setDetail(false)
  }
  const setSearchClose = () => {
    setSearchstop(false)
  }
  const setsetaddManualstopClose = () => {
    setaddManualstop(false)
  }
  const setstopDetailsOpen = () => {
    setStopDetails(true)
    setDetail(false)
  }
  const setstopDetailsClose = () => {
    setStopDetails(false)
  }

  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      // Generate filename with school name
      let filename = 'Routes'

      if (schoolName) {
        const school = schoolList?.find((s) => s.school_id === schoolName)
        if (school) {
          filename += `_${school.school_name.replace(/\s+/g, '_')}`
        }
      } else if (customRole === 'Admin' && userSchoolName) {
        filename += `_${userSchoolName.replace(/\s+/g, '_')}`
      }

      // Add current date
      const date = new Date().toISOString().split('T')[0]
      filename += `_${date}`

      // Export the data
      downloadCSV(rowData, filename)
      // toast.success(`${rowData.length} route records exported`)
    } else {
      toast.error('No data to export')
    }
  }

  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Routes'} subtitle={'Van / Route'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
        <ToolbarComponent
          classView
          handleOpen={() => setForm(true)}
          search={search}
          setSearchItem={setSearch}
          setPage={setPage} 
        >
          <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
        </ToolbarComponent>
      </div>
      <DataTable
        rowData={routeData}
        route
        refetch={refetch}
        headCells={routeHeadCells}
        handleDetailOpen={() => setDetail(true)}
        handleStopOpen={() => setStopOpen(true)}
        noDataMsg={no_data_msg}
        pageFee={page}
        setPageFee={setPage}
        setUpdate={setUpdate}
        pageCount={count}
        pages
      />
      {(form || update) && (
        <RouteForm
          open={form || update}
          handleClose={handleClose}
          customRole={customRole}
          userSchoolId={userSchoolId}
          update={update}
          step={step}
          setStep={setStep}
          refetch={refetch}
        />
      )}
      {detail && (
        <RouteDetail
          open={detail}
          handleClose={() => setDetail(false)}
          setstopDetailsOpen={setstopDetailsOpen}
          setHandleOpen={setsetaddManualstopOpen}
        />
      )}
      {stopOpen && (
        <AddStop
          open={stopOpen}
          setHandleOpen={setsetaddManualstopOpen}
          handleClose={() => setStopOpen(false)}
          setstopDetailsOpen={setstopDetailsOpen}
        />
      )}
      {addnew && (
        <AddNewStop
          addopen={addnew}
          setHandleOpen={setHandleOpen}
          setHandleClose={setHandleClose}
          setSearchOpen={setSearchOpen}
          setaddManualstopOpen={setsetaddManualstopOpen}
        />
      )}
      {searchStop && (
        <SearchStop
          addopen={searchStop}
          setHandleOpen={setSearchOpen}
          setHandleClose={setSearchClose}
        />
      )}
      {addManualStop && (
        <ManualStop
          addopen={addManualStop}
          setHandleOpen={setsetaddManualstopOpen}
          setHandleClose={setsetaddManualstopClose}
        />
      )}
      {stopDetails && (
        <StopDetail
          addopen={stopDetails}
          setHandleOpen={setstopDetailsOpen}
          setHandleClose={setstopDetailsClose}
          setManualHandleOpen={setsetaddManualstopOpen}
          setDetailOpen={() => {
            setDetail(true)
            setStopDetails(false)
          }}
        />
      )}
    </div>
  )
}
